"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKAutoComplete = void 0;
/* eslint-disable jsx-a11y/role-supports-aria-props */
var React = __importStar(require("react"));
var hooks_1 = require("../../common/hooks");
var components_1 = require("../../components");
var models_1 = require("../../models");
require("./GKAutoComplete.css");
var emptyTemplateComponent = function () { return (React.createElement("span", null, "No results found.")); };
var GKAutoCompleteDefinition = function (props, ref) {
    //#region Props Default/Destructure
    // Default props
    var uniqueId = (0, hooks_1.usePersistentId)(props.id, true)[0];
    var defaultedProps = (0, hooks_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-auto-complete",
        emptyTemplate: emptyTemplateComponent,
        filterFunction: function (datum, filter) {
            return (String(datum)
                .toLocaleLowerCase()
                .indexOf(filter ? filter.toLocaleLowerCase() : "") >= 0);
        },
        id: uniqueId,
        itemTemplate: function (datum, filter) {
            var template = (React.createElement(components_1.GKHighlightText, { match: filter }, (props.itemToString && props.itemToString(datum)) || String(datum)));
            return template;
        },
        itemToString: function (datum) { return String(datum); },
    });
    // Destructured props
    var passThroughClasses = defaultedProps.className, compact = defaultedProps.compact, disabled = defaultedProps.disabled, emptyTemplate = defaultedProps.emptyTemplate, enforceMenuPlacement = defaultedProps.enforceMenuPlacement, data = defaultedProps.data, qaProp = defaultedProps["data-qa"], filterFunction = defaultedProps.filterFunction, footerTemplate = defaultedProps.footerTemplate, headerTemplate = defaultedProps.headerTemplate, fullscreenCloseText = defaultedProps.fullscreenCloseText, hideClearButton = defaultedProps.hideClearButton, hideCollapseIcon = defaultedProps.hideCollapseIcon, icon = defaultedProps.icon, invalid = defaultedProps.invalid, 
    // Prop must be destructured to prevent passthrough
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    id = defaultedProps.id, isLoading = defaultedProps.isLoading, isOpenOverride = defaultedProps.isOpen, itemTemplate = defaultedProps.itemTemplate, itemToString = defaultedProps.itemToString, menuPlacement = defaultedProps.menuPlacement, onBlur = defaultedProps.onBlur, onChange = defaultedProps.onChange, onFocus = defaultedProps.onFocus, onMenuToggle = defaultedProps.onMenuToggle, onSelection = defaultedProps.onSelection, required = defaultedProps.required, selectedItem = defaultedProps.selectedItem, valid = defaultedProps.valid, otherProps = __rest(defaultedProps, ["className", "compact", "disabled", "emptyTemplate", "enforceMenuPlacement", "data", "data-qa", "filterFunction", "footerTemplate", "headerTemplate", "fullscreenCloseText", "hideClearButton", "hideCollapseIcon", "icon", "invalid", "id", "isLoading", "isOpen", "itemTemplate", "itemToString", "menuPlacement", "onBlur", "onChange", "onFocus", "onMenuToggle", "onSelection", "required", "selectedItem", "valid"]);
    //#endregion
    //#region  State
    var _a = React.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = React.useState(""), filterValue = _b[0], setFilterValue = _b[1];
    var _c = React.useState(props.data), filteredData = _c[0], setFilteredData = _c[1];
    var _d = React.useState(false), isEditing = _d[0], setIsEditing = _d[1];
    var _e = React.useState(false), hasFocus = _e[0], setHasFocus = _e[1];
    var _f = React.useState([]), selection = _f[0], setSelection = _f[1];
    var _g = React.useState(), keyboardController = _g[0], setKeyboardController = _g[1];
    //#endregion
    //#region Refs
    // internal refs
    var containerRef = React.useRef(null);
    var inputRef = React.useRef(null);
    var menuRef = React.useRef(null);
    // forwarded ref
    React.useImperativeHandle(ref, function () {
        return {
            close: closeMenu,
            open: openMenu,
            toggle: toggleMenu,
        };
    });
    //#endregion
    //#region Context
    var _h = (0, hooks_1.useDeviceSizes)(), isMobileSized = _h.isMobileSized, isDesktopSized = _h.isDesktopSized;
    var groupCtx = React.useContext(components_1.GKFormGroupContext);
    //#endregion
    //#region Local variables
    var menuId = uniqueId + "-menu";
    var inputContainerClasses = [
        "gk-auto-complete-input-container",
        icon && "gk-has-icon",
        filterValue && "gk-has-clear-button",
        isOpen ? "active" : !hideCollapseIcon && "caret",
    ]
        .filter(function (x) { return x; })
        .join(" ");
    var inputClasses = [
        valid && "is-valid",
        invalid && "is-invalid",
        passThroughClasses,
    ]
        .filter(function (x) { return x; })
        .join(" ");
    //#endregion
    //#region Actions
    var openMenu = function () {
        if (!disabled) {
            setIsOpen(true);
            setIsEditing(false);
        }
    };
    var closeMenu = function () {
        setIsOpen(false);
        setIsEditing(false);
    };
    var toggleMenu = function () {
        if (isOpen) {
            closeMenu();
        }
        else {
            openMenu();
        }
    };
    var focusInput = function () {
        var _a;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var selectInput = function () {
        var _a;
        if (isDesktopSized) {
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
        }
    };
    var updateInputFromSelection = function (sel) {
        setFilterValue(sel.length ? String(itemToString && itemToString(sel[0])) : "");
    };
    var clearInput = function () {
        updateInputFromSelection([]);
        focusInput();
        openMenu();
    };
    //#endregion
    //#region Handlers
    var onContainerFocus = function () {
        if (!hasFocus) {
            openMenu();
            selectInput();
            setHasFocus(true);
        }
    };
    var onInputBlur = function (e) {
        return onBlur && onBlur(e);
    };
    var onInputFocus = function (e) {
        setFilteredData(data);
        if (onFocus) {
            onFocus(e);
        }
    };
    var onInputChanged = function (e) {
        setFilterValue(e.target.value);
        setIsEditing(true);
        if (onChange) {
            onChange(e);
        }
    };
    var onInputKeyDown = function (e) {
        openMenu();
        if (keyboardController) {
            keyboardController.keyEventHandler(e);
        }
    };
    var onMenuChange = function (sel) {
        setSelection(sel);
        updateInputFromSelection(sel);
        closeMenu();
        focusInput();
        if (onSelection) {
            onSelection(sel instanceof Array ? sel[0] : sel);
        }
    };
    // Callback for when a close is triggered from within the menu or via a click outside the menu
    var onMenuClose = function (removeFocus) {
        updateInputFromSelection(selection);
        if (removeFocus) {
            setHasFocus(false);
        }
        closeMenu();
    };
    //#endregion
    // Handle outside click/touch and blur
    (0, hooks_1.useActionOutsideElement)(containerRef, function (val) {
        if (val && !isMobileSized) {
            onMenuClose(true);
        }
    });
    //#region Effects
    React.useEffect(function () {
        if (!isEditing || !filterValue || !filterFunction) {
            setFilteredData(data);
        }
        else {
            var newFilteredData = new models_1.Grouping("", data).filter(function (d) { return filterFunction(d, filterValue); }, function (g) { return g.children.length > 0; });
            setFilteredData((newFilteredData && newFilteredData.children) || []);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, filterValue]);
    React.useEffect(function () {
        var sel = selectedItem ? [selectedItem] : [];
        setSelection(sel);
        updateInputFromSelection(sel);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedItem]);
    React.useEffect(function () {
        var _a;
        (_a = groupCtx.setValidation) === null || _a === void 0 ? void 0 : _a.call(groupCtx, invalid === true ? false : valid === true ? true : undefined);
    }, [groupCtx, invalid, valid]);
    React.useEffect(function () {
        groupCtx.setRequired(required);
    }, [groupCtx, required]);
    React.useEffect(function () {
        var _a;
        (_a = groupCtx.setDisabled) === null || _a === void 0 ? void 0 : _a.call(groupCtx, disabled);
    }, [groupCtx, disabled]);
    //#endregion
    var selectionMenuProps = {
        anchorRef: inputRef,
        autoFocus: false,
        className: "gk-auto-complete-menu",
        closeOnSelect: false,
        compact: compact,
        data: filteredData,
        "data-qa": qaProp + "--menu",
        emptyTemplate: (function () {
            return emptyTemplate && emptyTemplate(filterValue);
        }),
        enforcePlacement: enforceMenuPlacement,
        footerTemplate: footerTemplate,
        fullscreenCloseText: fullscreenCloseText,
        headerTemplate: isMobileSized
            ? function () { return (React.createElement(React.Fragment, null,
                React.createElement(components_1.GKInput, __assign({ "data-qa": qaProp + "--fullscreen-input", type: "text", "aria-label": "Auto Complete", "aria-expanded": true, "aria-haspopup": "menu", "aria-controls": menuId, "aria-activedescendant": menuRef.current && hasFocus && isOpen ? menuId : undefined, autoComplete: "off", 
                    // I consider this okay because it only renders when the menu opens.
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus: true, disabled: disabled, onChange: onInputChanged, onFocus: onInputFocus, onBlur: onInputBlur, value: filterValue, onKeyDown: onInputKeyDown }, otherProps)), headerTemplate === null || headerTemplate === void 0 ? void 0 :
                headerTemplate())); }
            : headerTemplate,
        id: menuId,
        isLoading: isLoading,
        isOpen: isOpenOverride || isOpen,
        itemTemplate: (function (item) {
            return itemTemplate && itemTemplate(item, filterValue);
        }),
        itemToString: itemToString,
        onChange: onMenuChange,
        onClose: onMenuClose,
        onMenuToggle: onMenuToggle,
        placement: menuPlacement || "bottom-start",
        selectMultiple: false,
        selection: selection,
    };
    return (React.createElement("div", { id: uniqueId, className: "gk-auto-complete", ref: containerRef, "data-qa": qaProp },
        React.createElement("div", { onFocus: onContainerFocus, className: inputContainerClasses },
            icon ? (React.createElement("span", { className: "gk-auto-complete-icon-container" },
                React.createElement(components_1.GKIcon, { className: "gk-auto-complete-icon", name: icon }))) : null,
            React.createElement("input", __assign({ id: uniqueId + "-input", className: "gk-auto-complete-input form-control " + inputClasses, type: "text", "aria-label": "Auto Complete", "aria-expanded": isOpen, "aria-haspopup": "menu", "aria-controls": menuId, "aria-activedescendant": menuRef.current && hasFocus && isOpen ? menuId : undefined, autoComplete: "off", disabled: disabled, name: uniqueId, onChange: onInputChanged, value: filterValue, onClick: openMenu, onBlur: onInputBlur, onFocus: onInputFocus, onKeyDown: onInputKeyDown, "data-qa": qaProp + "--input" }, otherProps, { ref: inputRef })),
            filterValue && isOpen && !hideClearButton ? (React.createElement(components_1.GKIconButton, { icon: components_1.GKIconName.Clear, onClick: clearInput, "data-qa": qaProp + "--clear" })) : null),
        React.createElement(components_1.GKSelectionMenu, __assign({}, selectionMenuProps, { ref: function (ref) {
                setKeyboardController(ref ? ref.keyboardController : undefined);
            } }))));
};
exports.GKAutoComplete = React.forwardRef(GKAutoCompleteDefinition);
exports.default = exports.GKAutoComplete;
